import { useQuery } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { useApplicationParameters } from "src/api/client-api/appParams/useApplicationParameters";
import { useUserNew } from "src/api/client-api/useUserNew";

export const SOCIAL_NOTIFICATIONS_KEY = "social-notifications" as const;

export type SocialNotification = {
    type: "post_created" | "comment_on_post" | "reply_to_comment" | "post_reaction" | "comment_reaction" | "mention";
    subject_id: number;
    excerpt: string;
    created_at: string;
    actor_firstname: string | null;
    actor_lastname: string | null;
};

export type SocialNotificationsResponse = {
    unreadCount: number;
    notifications: SocialNotification[];
};

export const useSocialNotifications = () => {
    const { applicationParameters } = useApplicationParameters();
    const { user } = useUserNew();
    const isNewsFeedEnabled = applicationParameters?.["FS-news-feed"] === "true";

    return useQuery({
        queryKey: [SOCIAL_NOTIFICATIONS_KEY, user?.id, user?.socialLastSeenAt ?? null],
        enabled: Boolean(isNewsFeedEnabled && user?.id),
        staleTime: 1000 * 60,
        refetchInterval: 1000 * 60,
        refetchOnWindowFocus: true,
        queryFn: async () => {
            const response = await loggedInApiCall.get<SocialNotificationsResponse>("/api/social/notifications");

            return response.data;
        },
    });
};
